'use client';

import { c as _c } from "react/compiler-runtime";
import ListItemButton from '@mui/material/ListItemButton';
import { Modal } from '@/app/_shared/components/Modal';
import { type Changelog } from 'resonetics-webapps-modules';
import { startTransition, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Box from '@mui/material/Box';
import React from 'react';
import HorizontalRule from '@mui/icons-material/HorizontalRule';
const VERSION_STORAGE_KEY = 'version';
function useIsNewVersion(appVersion) {
  const $ = _c(3);
  const [isANewVersion, setIsANewVersion] = useState(false);
  let t0;
  let t1;
  if ($[0] !== appVersion) {
    t0 = () => {
      const storedVersion = localStorage.getItem(VERSION_STORAGE_KEY);
      if (storedVersion === appVersion) {
        return;
      }
      if (storedVersion) {
        startTransition(() => {
          setIsANewVersion(true);
        });
      }
      localStorage.setItem(VERSION_STORAGE_KEY, appVersion);
    };
    t1 = [appVersion];
    $[0] = appVersion;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isANewVersion;
}
interface VersionChangelogButtonProps {
  changelog: Changelog;
  appVersion: string;
}
export const VersionChangelogButton: React.FC<VersionChangelogButtonProps> = t0 => {
  const $ = _c(16);
  const {
    changelog,
    appVersion
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const isANewVersion = useIsNewVersion(appVersion);
  let t1;
  let t2;
  if ($[0] !== isANewVersion) {
    t1 = () => {
      startTransition(() => {
        if (isANewVersion) {
          setIsOpen(true);
        }
      });
    };
    t2 = [isANewVersion];
    $[0] = isANewVersion;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(true);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== appVersion) {
    t4 = <ListItemButton onClick={t3} sx={_temp}>v{appVersion}</ListItemButton>;
    $[4] = appVersion;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsOpen(false);
    t6 = {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: 3
      }
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== changelog) {
    t7 = changelog.map(_temp5);
    $[8] = changelog;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isOpen || $[11] !== t7) {
    t8 = <Modal title="Changelog" isOpen={isOpen} onClose={t5} ContentProps={t6}>{t7}</Modal>;
    $[10] = isOpen;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <>{t4}{t8}</>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
function _temp(t0) {
  const {
    palette,
    typography
  } = t0;
  return {
    color: palette.grey[300],
    fontSize: typography.caption,
    p: 0,
    pl: 0.3
  };
}
function _temp2(t0) {
  const [, changes] = t0;
  return changes.length > 0;
}
function _temp3(t0) {
  const {
    palette: palette_0
  } = t0;
  return {
    borderBottom: `2px solid ${palette_0.grey[600]}`
  };
}
function _temp4(change, i) {
  return <ListItem key={i}><Typography fontSize={15}><HorizontalRule sx={{
        fontSize: 12,
        mr: 1
      }} />{change}</Typography></ListItem>;
}
function _temp5(release) {
  const filteredChanges = Object.entries(release.changes).filter(_temp2);
  return <Table key={release.version}><TableHead sx={_temp3}><TableRow><TableCell sx={{
          fontWeight: 600,
          fontSize: 20
        }}>{release.version}</TableCell><TableCell sx={{
          fontWeight: 400,
          fontSize: 16,
          textAlign: "right"
        }}>{release.date}</TableCell></TableRow></TableHead><TableBody>{filteredChanges.map((t0, rowI) => {
        const [changeType, changes_0] = t0;
        return <TableRow key={changes_0}><TableCell colSpan={2} sx={{
            fontWeight: 600,
            pt: 2,
            borderBottom: rowI === filteredChanges.length - 1 ? "none" : undefined
          }}><Box>{changeType}{(changes_0 as string[]).map(_temp4)}</Box></TableCell></TableRow>;
      })}</TableBody></Table>;
}